import React from 'react'
import EtText from '../../EtText.jsx'
import { body } from '../../assets/strings/StainlessInfo'

const StainlessInfo = () => <EtText>{body}</EtText>

export default StainlessInfo
